import { render, staticRenderFns } from "./threadItem.vue?vue&type=template&id=69702a8e&"
import script from "./threadItem.vue?vue&type=script&lang=js&"
export * from "./threadItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports